import s from './profile-select.module.scss'
import { useProfile } from '@shared/api/useProfile'
import { useProfiles } from '@entities/profile/api/useProfiles'
import { useActiveProfile } from '@shared/context/ActiveProfileContext'
import { Loader } from '@shared/ui/loader/loader'
import { Navigate, useNavigate } from 'react-router-dom'
import { getAvatarUrl } from '@utils/lib/getAvatarUrl'

const avatarUrl = getAvatarUrl

// Экран выбора активного профиля (постановка «Родители и дети»).
// Показывается, когда в аккаунте несколько профилей и ни один не выбран.
export const ProfileSelectPage = () => {
	const { data: account, isFetched: accountFetched } = useProfile()
	const { data: profiles = [], isFetched: profilesFetched } = useProfiles()
	const { activeProfile, setActiveProfile } = useActiveProfile()
	const navigate = useNavigate()

	if (!accountFetched || !profilesFetched) {
		return <div style={{ height: '100svh', width: '100vw' }}><Loader /></div>
	}

	// Профиль уже выбран или выбирать не из чего — возвращаемся в дашборд
	if (activeProfile || profiles.length <= 1) {
		return <Navigate to="/" replace />
	}

	const selectOwner = () => {
		setActiveProfile(null)
		navigate('/')
	}

	const selectProfile = (profile) => {
		setActiveProfile(profile)
		navigate('/')
	}

	return (
		<div className={s.wrapper}>
			<div className={s.logo}>
				<img src={process.env.REACT_APP_STORAGE_URL + "images/logo.svg"} alt="Созвучно - сервис по поиску преподавателей музыки" />
			</div>
			<h1 className={s.title}>Кто будет заниматься?</h1>
			<p className={s.subtitle}>Выберите профиль, с которым вы хотите работать</p>
			<div className={s.cards}>
				<button type="button" className={`${s.card} ${s.ownerCard}`} onClick={selectOwner}>
					<div className={s.avatar}>
						<img src={avatarUrl(account?.avatar)} alt="" />
					</div>
					<span className={s.name}>{account?.name}</span>
					<span className={s.badge}>Я (родитель)</span>
				</button>
				{profiles.map((profile) => (
					<button key={profile.id} type="button" className={s.card} onClick={() => selectProfile(profile)}>
						<div className={s.avatar}>
							<img src={avatarUrl(profile.avatar)} alt="" />
						</div>
						<span className={s.name}>{profile.name}</span>
						<span className={s.badge}>Ребёнок</span>
					</button>
				))}
			</div>
		</div>
	)
}
